import { memo } from 'react';

function CompanyAddressIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#919EAB" fillOpacity="0.24" />
      <path
        d="M21.5 17.5C21.5 18.3284 20.8284 19 20 19C19.1716 19 18.5 18.3284 18.5 17.5C18.5 16.6716 19.1716 16 20 16C20.8284 16 21.5 16.6716 21.5 17.5Z"
        fill="#637381"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17.92C12.0439 13.533 15.6128 9.99978 20 10C24.3872 9.99978 27.9561 13.533 28 17.92C28 23.4 21 29.5 20.65 29.76C20.2758 30.0801 19.7242 30.0801 19.35 29.76L19.3484 29.7586C19.0254 29.4787 12 23.3904 12 17.92ZM16.5 17.5C16.5 19.433 18.067 21 20 21C20.9283 21 21.8185 20.6313 22.4749 19.9749C23.1313 19.3185 23.5 18.4283 23.5 17.5C23.5 15.567 21.933 14 20 14C18.067 14 16.5 15.567 16.5 17.5Z"
        fill="#637381"
      />
    </svg>
  );
}

export default memo(CompanyAddressIcon);
